import dayjs from 'dayjs/esm/index.js'

export const setInitialYear = (data: object) => {
  const route = useRoute()
  const router = useRouter()

  const isYear = (year: string) => {
    if (!year) return false
    const parsed = Number(year)
    return !isNaN(parsed) && parsed >= 2000 && year.length === 4
  }
  const intialYear = isYear(route?.query?.year) ? Number(route?.query?.year) : dayjs().year()

  return intialYear
}
